// frontend/src/main.tsx
import React from 'react'; // Importation de React pour utiliser JSX
import ReactDOM from 'react-dom/client'; // Importation de ReactDOM pour le rendu dans le DOM
import App from './App'; // Importation du composant principal de l'application
import './styles.css'; // Importation des styles globaux

// Rendu de l'application dans l'élément root du DOM
// Utilise ReactDOM.createRoot pour activer le mode concurrent de React
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode> {/* Mode strict pour détecter les problèmes potentiels */}
    <App /> {/* Rend le composant principal */}
  </React.StrictMode>
);